import { Alert, Button, Flex, Radio, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { OrganisationClaim } from "shell/api/types";

interface Props {
  error: string;
  onSubmit: (values: { organisationId: string }) => void;
  organisations: OrganisationClaim[];
}

export const OrgSelectionForm = ({ organisations, error, onSubmit }: Props) => {
  const { t } = useTranslation(["common"]);
  const [selectedId, setSelectedId] = useState(
    organisations[0]?.organisation_id,
  );

  return (
    <Flex vertical gap="middle">
      {error && <Alert type="error" title={error} showIcon />}

      <Typography.Text type="secondary">
        {t("passwordLogin.orgSelection.prompt")}
      </Typography.Text>

      <Radio.Group
        value={selectedId}
        onChange={event => setSelectedId(event.target.value)}
      >
        <Flex vertical gap="small">
          {organisations.map(organisation => (
            <Radio
              key={organisation.organisation_id}
              value={organisation.organisation_id}
            >
              {organisation.name}
            </Radio>
          ))}
        </Flex>
      </Radio.Group>

      <Button
        type="primary"
        block
        size="large"
        disabled={!selectedId}
        onClick={() => selectedId && onSubmit({ organisationId: selectedId })}
      >
        {t("idpDiscovery.continue")}
      </Button>
    </Flex>
  );
};
